//-----------------------------
// calc current characteristic
//-----------------------------
export default function calcCurrentCharacteristic(parm) {
  // console.log("---------------------------------");
  // console.log("IN calcCurrentCharacteristic");
  let cur
  const integs_tot = Number(parm.integs_tot) || 0
  const wounds_tot = Number(parm.wounds_tot) || 0
  // console.log("parm.rolled = " + parm.rolled);
  // console.log("parm.integs_tot = " + parm.integs_tot);
  // console.log("parm.improvs_tot = " + parm.improvs_tot);
  // console.log("parm.adjs_tot = " + parm.adjs_tot);
  //
  if (integs_tot) {
    cur = parm.rolled - integs_tot + parm.improvs_tot + parm.adjs_tot
  } else if (wounds_tot) {
    cur = parm.rolled - wounds_tot + parm.improvs_tot + parm.adjs_tot
  } else {
    cur = parm.rolled + parm.improvs_tot + parm.adjs_tot
  }
  // console.log("cur = " + cur);
  return cur
}
